import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import CheckoutForm from '../stripe/CheckoutForm';
import { RETURN_PATHS } from '../../service/checkoutReturn';

import '../../styles/App.css';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

// Stripe Elements checkout for confirming a payment plan's first
// installment. The clientSecret comes from POST /api/me/payment-plans and
// is the PaymentIntent on the new subscription's first invoice (created
// with payment_behavior: 'default_incomplete') — it confirms exactly like
// a one-off PaymentIntent, so this reuses the same CheckoutForm as the
// single-invoice flow (see InvoiceCheckout.js). Lands on CheckoutSuccess
// with ?context=plan rather than dumping the member back on My Account
// with no confirmation.
export default function PaymentPlanCheckout({ clientSecret, addressDefaults = null }) {
  if (!clientSecret) return null;
  if (!stripePromise) {
    return <p>Payments are not available right now. Please try again later.</p>;
  }

  const options = {
    clientSecret,
    appearance: { theme: 'stripe' },
  };

  return (
    <Elements options={options} stripe={stripePromise}>
      <CheckoutForm
        paymentType="payment_plan"
        returnPath={RETURN_PATHS.paymentPlan}
        addressMode="billing"
        addressDefaults={addressDefaults}
      />
    </Elements>
  );
}
